import Container from "./Container";
import faroLogo from "../assets/faro.png";

export default function Footer({ onNavigate, t }) {
  return (
    <footer className="border-t border-slate-200 py-10">
      <Container className="grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src={faroLogo} alt="FARO Logo" className="h-8 w-8 object-contain" />
            <div className="text-lg font-semibold text-slate-900">FARO</div>
          </div>
          <p className="mt-3 text-sm text-slate-600">{t.footer.description}</p>
        </div>
        <div>
          <div className="text-sm font-semibold text-slate-900">{t.footer.companyTitle}</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><button onClick={() => onNavigate("home")} className="hover:text-[#0B1F3A]">{t.footer.home}</button></li>
            <li><button onClick={() => onNavigate("contact")} className="hover:text-[#0B1F3A]">{t.footer.contact}</button></li>
            <li><button onClick={() => onNavigate("security")} className="hover:text-[#0B1F3A]">{t.footer.security}</button></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-slate-900">{t.footer.contactTitle}</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li>{t.footer.emailLabel}: <a className="text-[#0B1F3A] hover:underline" href="mailto:contacto@farolabs.dev">contacto@farolabs.dev</a></li>
            <li>{t.footer.location}</li>
          </ul>
        </div>
      </Container>
      <Container className="mt-8 border-t border-slate-200 pt-6 text-xs text-slate-500">
        © {new Date().getFullYear()} FARO. {t.footer.rights}
      </Container>
    </footer>
  );
}

